/* Dekofar V2 - stock based variant visibility.
   Completely out-of-stock option values are hidden; package sizes stay visible
   with an unavailable state for the currently selected colour/model. */
(function (window, document) {
  'use strict';
  function update(root) {
    if (!root || !root.querySelector) return;
    var json = root.querySelector('[data-dekofar-v2-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    if (!product || !Array.isArray(product.variants)) return;
    var available = product.variants.filter(function (v) { return v && v.available && Array.isArray(v.options); });
    var options = Array.from(root.querySelectorAll('[data-dekofar-v2-variants] select[data-option-position], [data-dekofar-v2-shoe-select]'));
    var seen = {};
    options.forEach(function (select) {
      var position = Number(select.getAttribute('data-option-position'));
      if (!position || seen[position]) return;
      seen[position] = true;
      var index = position - 1;
      var name = (select.getAttribute('name') || '').toLocaleLowerCase('tr-TR');
      var isPackage = /kg|paket|boyut|hacim|litre|\blt\b|beden|numara/.test(name);
      // Footwear sizes have no second-level package stock indicator: hide sold-out sizes.
      if (select.hasAttribute('data-dekofar-v2-shoe-select')) isPackage = false;
      var container = select.closest('[data-dekofar-v2-option]');
      if (!container) return;
      var cards = container.querySelectorAll('[data-dekofar-v2-color-value], [data-dekofar-v2-package-value], [data-dekofar-v2-standard-value], [data-dekofar-v2-shoe-value]');
      cards.forEach(function (card) {
        var value = card.getAttribute('data-dekofar-v2-color-value') ||
          card.getAttribute('data-dekofar-v2-package-value') ||
          card.getAttribute('data-dekofar-v2-standard-value') ||
          card.getAttribute('data-dekofar-v2-shoe-value');
        var existsInStock = available.some(function (variant) { return variant.options[index] === value; });
        // A size/package stays visible when any combination of that value is in stock.
        // This lets the existing variant selector show "Stok Yok" for the selected colour.
        var hide = !existsInStock && !isPackage;
        card.toggleAttribute('data-dekofar-stock-hidden', hide);
        if (hide) { card.disabled = true; card.setAttribute('aria-disabled', 'true'); }
      });
    });
  }
  function init(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    if (parent.matches && parent.matches('[data-dekofar-v2-product]')) update(parent);
    parent.querySelectorAll('[data-dekofar-v2-product]').forEach(update);
  }
  window.dekofarV2UpdateStockVisibility = init;
  document.addEventListener('dekofar:v2:variant-change', function (event) {
    var root = event.target.closest && event.target.closest('[data-dekofar-v2-product]');
    if (root) update(root);
  });
})(window, document);
